import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-spi-blue text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <Logo variant="light" size="lg" />
          <p className="mt-6 text-sm text-slate-300 leading-relaxed max-w-md">
            Swiss Premium Insurance — service privé et indépendant d'optimisation
            et d'intermédiation en assurance. Vérification d'éligibilité aux
            subsides, comparatif gratuit et accompagnement administratif personnalisé.
          </p>
          <p className="mt-6 text-xs text-slate-400 leading-relaxed">
            Service privé indépendant sans lien avec les administrations publiques.
            <br />
            Inscrit au registre fédéral des intermédiaires d'assurance (FINMA).
          </p>
        </div>

        <div className="lg:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-spi-red font-bold mb-4">
            Nous contacter
          </div>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-spi-red mt-0.5 flex-shrink-0" strokeWidth={1.75} />
              <a
                href="https://www.google.com/maps/search/?api=1&query=Pl.+de+Cornavin+14+1201+Geneve"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address"
                className="text-slate-200 hover:text-white transition-colors"
              >
                Pl. de Cornavin 14, 1201 Genève, Suisse
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-spi-red mt-0.5 flex-shrink-0" strokeWidth={1.75} />
              <a
                href="tel:+41225598684"
                data-testid="footer-phone"
                className="text-slate-200 hover:text-white transition-colors font-medium"
              >
                +41 22 559 86 84
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-spi-red mt-0.5 flex-shrink-0" strokeWidth={1.75} />
              <a
                href="mailto:contact@sp-insurance.ch"
                data-testid="footer-email"
                className="text-slate-200 hover:text-white transition-colors"
              >
                contact@sp-insurance.ch
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="w-4 h-4 text-spi-red mt-0.5 flex-shrink-0" strokeWidth={1.75} />
              <div className="text-slate-200" data-testid="footer-hours">
                <div>Lundi au Vendredi : 09:00 – 18:00</div>
                <div className="text-slate-400 text-xs mt-0.5">Samedi et Dimanche : Fermé</div>
              </div>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-spi-red font-bold mb-4">
            Navigation
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#comment-ca-marche" className="text-slate-300 hover:text-white transition-colors">Comment ça marche</a></li>
            <li><a href="/#services" className="text-slate-300 hover:text-white transition-colors">Services</a></li>
            <li><a href="/#simulateur" className="text-slate-300 hover:text-white transition-colors">Simulateur</a></li>
            <li><a href="/#rendez-vous" className="text-slate-300 hover:text-white transition-colors">Rendez-vous</a></li>
            <li><a href="/#avis" className="text-slate-300 hover:text-white transition-colors">Avis Google</a></li>
            <li><a href="/#contact" className="text-slate-300 hover:text-white transition-colors">Contact</a></li>
          </ul>

          <div className="text-xs uppercase tracking-[0.2em] text-spi-red font-bold mt-8 mb-4">
            Légal
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/politique-confidentialite"
                data-testid="footer-confidentialite"
                className="text-white underline decoration-spi-red decoration-2 underline-offset-4 hover:text-spi-red transition-colors font-medium"
              >
                Politique de confidentialité
              </Link>
            </li>
            <li>
              <Link
                to="/mentions-legales"
                data-testid="footer-mentions"
                className="text-white underline decoration-spi-red decoration-2 underline-offset-4 hover:text-spi-red transition-colors font-medium"
              >
                Mentions légales
              </Link>
            </li>
            <li>
              <button
                data-testid="footer-cookies"
                onClick={() => {
                  localStorage.removeItem("cookie-consent");
                  window.location.reload();
                }}
                className="text-slate-300 hover:text-white transition-colors text-left"
              >
                Gérer les cookies
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Swiss Premium Insurance. Tous droits réservés.</div>
          <div className="italic">Service privé indépendant sans lien avec les administrations publiques.</div>
        </div>
      </div>
    </footer>
  );
}
